import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;

  section {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 18px;

    & h3 {
      margin-bottom: 30px;
      font-size: 20px;
    }
  }

  .message {
    margin-top: 5px;
    font-style: italic;
    font-size: 14px;
    text-align: center;
  }

  .saveButton {
    width: max-content;
    padding: 20px;
    float: right;
  }

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }
  
  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
